var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06699 0.25C3.25944 -0.0833334 3.74056 -0.0833333 3.93301 0.25L6.09808 4C6.29053 4.33333 6.04996 4.75 5.66506 4.75H1.33494C0.950036 4.75 0.709474 4.33333 0.901924 4L3.06699 0.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnArrow);
export default __webpack_public_path__ + "static/media/column-arrow.c4e375fd9bbddaaeeeff63a93d244529.svg";
export { ForwardRef as ReactComponent };